module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Edit/create Param sets")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showCreateParamSetDialog = true
      }
    }
  }, [_vm._v("Create Param set")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "display": "inline-block",
      "width": "80%",
      "margin": "0 0 10px 10px"
    },
    attrs: {
      "data-vv-delay": "1000",
      "name": "searchString",
      "type": "text",
      "placeholder": "search HB Unit by HB Unit tag (type and enter)"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterHbparamset()
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "clearSearch",
      "placement": "top"
    }
  }, [_c('el-button', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "danger",
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.clearSearch()
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "element-promt",
    attrs: {
      "title": "Clone param set",
      "visible": _vm.showAliasNameDialog,
      "width": "40%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.showAliasNameDialog = $event
      }
    }
  }, [_c('h5', [_vm._v("Alias name")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "text",
      "rows": 10
    },
    model: {
      value: (_vm.cloneParamSet.alias),
      callback: function($$v) {
        _vm.$set(_vm.cloneParamSet, "alias", $$v)
      },
      expression: "cloneParamSet.alias"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("IS AMP?")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "disabled": _vm.cloningSet && _vm.cloningSet.is_amp
    },
    model: {
      value: (_vm.cloneParamSet.is_amp),
      callback: function($$v) {
        _vm.$set(_vm.cloneParamSet, "is_amp", $$v)
      },
      expression: "cloneParamSet.is_amp"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cloneParamSetSubmit
    }
  }, [_vm._v("Create clone")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "element-promt",
    attrs: {
      "title": "Input alias name",
      "visible": _vm.showCreateParamSetDialog,
      "width": "40%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.showCreateParamSetDialog = $event
      }
    }
  }, [_c('h5', [_vm._v("Alias name")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "text",
      "rows": 10
    },
    model: {
      value: (_vm.newParamSet.alias),
      callback: function($$v) {
        _vm.$set(_vm.newParamSet, "alias", $$v)
      },
      expression: "newParamSet.alias"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("IS AMP?")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.newParamSet.is_amp),
      callback: function($$v) {
        _vm.$set(_vm.newParamSet, "is_amp", $$v)
      },
      expression: "newParamSet.is_amp"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Dimension")]), _vm._v(" "), _c('el-select', {
    staticClass: "param-set-input select-input",
    attrs: {
      "filterable": "",
      "placeholder": "Select dimension"
    },
    model: {
      value: (_vm.newParamSet.dimension),
      callback: function($$v) {
        _vm.$set(_vm.newParamSet, "dimension", $$v)
      },
      expression: "newParamSet.dimension"
    }
  }, _vm._l((_vm.dimensions), function(dimension) {
    return _c('el-option', {
      key: dimension.id,
      attrs: {
        "label": ((dimension.width) + "X" + (dimension.height)),
        "value": dimension.id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.createParamSetButtonValid,
      "type": "primary"
    },
    on: {
      "click": _vm.createParamSet
    }
  }, [_vm._v("Create Param set")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.param_sets), function(param_set) {
    return _c('div', [_c('el-collapse', {
      attrs: {
        "accordion": ""
      },
      on: {
        "change": _vm.handleChange
      },
      model: {
        value: (_vm.activeNames),
        callback: function($$v) {
          _vm.activeNames = $$v
        },
        expression: "activeNames"
      }
    }, [_c('el-collapse-item', {
      staticClass: "collapse--item",
      class: {
        recentlyClosed: _vm.recentlyClosed == param_set.alias,
          opened: _vm.activeNames == param_set.alias,
      },
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "title": param_set.alias,
        "name": param_set.alias
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_c('div', [_c('h5', [_vm._v("\n                                                            " + _vm._s(param_set.alias) + " -\n                                                            "), _c('span', {
      staticClass: "param-type"
    }, [_vm._v("(" + _vm._s(param_set.is_amp ? 'AMP' : 'Display') + ")")]), (!param_set.id) ? _c('span', {
      staticStyle: {
        "color": "red",
        "font-style": "italic"
      }
    }, [_vm._v("* NOT SAVED")]) : _vm._e()])])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "grid-content",
      staticStyle: {
        "overflow": "scroll"
      }
    }, [_c('div', {
      staticClass: "enabled-bidders"
    }, [_vm._l((_vm.getEnabledBidders(param_set.params)), function(bidder) {
      return _c('p', [_vm._v("\n                                                            " + _vm._s(bidder) + "\n                                                        ")])
    }), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.getEnabledBidders(param_set.params).length == 0),
        expression: "getEnabledBidders(param_set.params).length == 0"
      }],
      staticStyle: {
        "color": "#a13333"
      }
    }, [_vm._v("\n                                                            No bidders enabled\n                                                        ")])], 2)])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "span": 2
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_c('div', [_c('el-button', {
      staticClass: "el-button el-button--info",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.cloneDialog(param_set)
        }
      }
    }, [_vm._v("\n                                                            Clone Param Set\n                                                        ")])], 1)])])], 1)], 1), _vm._v(" "), (_vm.activeNames == param_set.alias) ? _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, _vm._l((param_set.is_amp ? _vm.ampBidders : _vm.bidders), function(bidder) {
      return ((param_set.is_amp && bidder.amp_enabled) || !param_set.is_amp) ? _c('div', {
        staticClass: "col-md-12",
        class: {
          'bidder-params-box': param_set.params[bidder.code]['enabled'],
            'bidder-params': true,
        },
        staticStyle: {
          "width": "98%",
          "left": "1%"
        }
      }, [_c('div', [_c('el-checkbox', {
        attrs: {
          "name": "bidder[]",
          "id": ((param_set.id) + "-" + (bidder.code))
        },
        model: {
          value: (param_set.params[bidder.code]['enabled']),
          callback: function($$v) {
            _vm.$set(param_set.params[bidder.code], 'enabled', $$v)
          },
          expression: "param_set.params[bidder.code]['enabled']"
        }
      }, [_vm._v("\n                                                    " + _vm._s(bidder.name) + "\n                                                    ")])], 1), _vm._v(" "), _vm._l((_vm.getBidderFields(bidder, param_set.is_amp)), function(field) {
        return (param_set.params[bidder.code]['enabled']) ? _c('div', {
          staticClass: "col-md-4"
        }, [(field.type == 'text') ? _c('div', {
          staticClass: "form-group"
        }, [_c('div', [_c('p', {
          staticClass: "bold pull-left",
          attrs: {
            "for": field.label
          }
        }, [_vm._v("\n                                                            " + _vm._s(field.label) + "\n                                                        ")]), _vm._v(" "), _c('input', {
          directives: [{
            name: "trim",
            rawName: "v-trim"
          }, {
            name: "model",
            rawName: "v-model",
            value: (
              param_set.params[bidder.code]['bidder_params'][
                field.name
              ]
            ),
            expression: "\n                                                                param_set.params[bidder.code]['bidder_params'][\n                                                                    field.name\n                                                                ]\n                                                            "
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "id": field.label
          },
          domProps: {
            "value": (
              param_set.params[bidder.code]['bidder_params'][
                field.name
              ]
            )
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(param_set.params[bidder.code]['bidder_params'],
                field.name, $event.target.value)
            }
          }
        })])]) : _vm._e(), _vm._v(" "), (field.type == 'number' || field.type == 'float') ? _c('div', {
          staticClass: "form-group"
        }, [_c('div', [_c('p', {
          staticClass: "bold pull-left",
          attrs: {
            "for": field.label
          }
        }, [_vm._v("\n                                                            " + _vm._s(field.label) + "\n                                                        ")]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model.number",
            value: (
              param_set.params[bidder.code]['bidder_params'][
                field.name
              ]
            ),
            expression: "\n                                                                param_set.params[bidder.code]['bidder_params'][\n                                                                    field.name\n                                                                ]\n                                                            ",
            modifiers: {
              "number": true
            }
          }],
          staticClass: "form-control",
          attrs: {
            "type": "number",
            "id": "field.label",
            "step": "0.01"
          },
          domProps: {
            "value": (
              param_set.params[bidder.code]['bidder_params'][
                field.name
              ]
            )
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(param_set.params[bidder.code]['bidder_params'],
                field.name, _vm._n($event.target.value))
            },
            "blur": function($event) {
              return _vm.$forceUpdate()
            }
          }
        })])]) : _vm._e()]) : _vm._e()
      })], 2) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right",
        "margin": "10px"
      },
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.applyTagParamSetBidder(param_set)
        }
      }
    }, [_vm._v("Apply")])], 2)], 1)], 1)
  }), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    },
    attrs: {
      "page-size": _vm.offset,
      "pager-count": 20,
      "layout": "prev, pager, next",
      "total": _vm.total_pages,
      "current-page": _vm.currentPage
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 2)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b7e421c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dfp/HbTagParamSet.vue
// module id = 703
// module chunks = 2